import { UseGetAllPageSizeProps } from '_api/queries/types';
import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Resource } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

export const GET_MY_LIBRARY_RESOURCES_KEY = 'get-my-library-resources';

export const useGetMyLibraryResources = ({
  page = 0,
  size = 10,
}: UseGetAllPageSizeProps) => {
  return usePermittedQuery<Resource[]>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () => `/resource/my-library?page=${page}&size=${size}`,
    {},
    [GET_MY_LIBRARY_RESOURCES_KEY],
    {
      enabled: typeof page === 'number' && page >= 0,
      refetchOnWindowFocus: false,
    },
  );
};
